import React from 'react';
import PropTypes from 'prop-types';

import '../styles/SetMenu.css';
import MenuHeader from './MenuHeader';

const SetMenu = ({ name, settings, parentName, index }) => {
    const buttonClassName = index === -1 ? 'Set-button Button-active' : 'Set-button';
    const currentOptionIndex = index;
    return (
      <>
        <MenuHeader itemName={name} parentItemName={parentName} />
        <div className="Set-options-container">
          {settings.map((option, index) => {
            const itemClassName = index === currentOptionIndex ? 'Set-option-item Set-option-item-active' : 'Set-option-item';
            return <div key={index} className={itemClassName}>{option}</div>;
          })}
          <div className={buttonClassName}>Set</div>
        </div>
      </>
    );
  };
  
SetMenu.propTypes = {
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  parentName: PropTypes.string,
  settings: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SetMenu;